import React from 'react';
import PropTypes from 'prop-types';

const CompanySearchListTeaser = ({ hit, active, onClick }) => {
    const {
        logo,
        title,
        description,
        website,
        email,
        phone,
    } = hit.data;

    return (
        <button className="company-search-list-teaser" onClick={onClick} role="button" aria-selected={active ? 'true' : 'false'} data-company-search-list-teaser={hit.id}>
            <div className="company-search-list-teaser__logo">
                {logo && (
                    <img src={logo} alt={title} role="presentation" />
                )}
            </div>
            <div className="company-search-list-teaser__content">
                <h3 className="company-search-list-teaser__title">{title}</h3>
                {description && (
                    <p className="company-search-list-teaser__description">{description}</p>
                )}
                {(website || email || phone) && (
                    <div className="company-search-list-teaser__information">
                        {[
                            { icon: 'website', label: website.replace('https://', '').replace('www.', '') },
                            { icon: 'email', label: email },
                            { icon: 'phone', label: phone },
                        ].filter(item => item.label).map((item) => (
                            <div className="company-search-list-teaser__information-item" key={item.icon}>
                                <svg viewBox="0 0 24 24">
                                    <use xlinkHref={`#icon-${item.icon}`} />
                                </svg>
                                {item.label}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </button>
    );
}

CompanySearchListTeaser.propTypes = {
    hit: PropTypes.shape({}).isRequired,
};

export { CompanySearchListTeaser };
